import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './SideNav.css';

const SideNav = ({ onNavigate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const handleNavigation = (path) => {
    setIsOpen(false);
    
    // If on home page and onNavigate callback exists, use it for validation
    if (isHomePage && onNavigate) {
      onNavigate(path);
    } else {
      navigate(path);
    }
  };

  const toggleExpand = (itemKey) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemKey]: !prev[itemKey]
    }));
  };

  const handleItemClick = (itemKey) => {
    // Toggle selection - if already selected, deselect it
    if (selectedItem === itemKey) {
      setSelectedItem(null);
    } else {
      setSelectedItem(itemKey);
    }
    toggleExpand(itemKey);
  };

  return (
    <>
      <button 
        className={`hamburger-menu ${isOpen ? 'menu-open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        <img 
          src={isOpen ? "/images/HamburgerMenuClose.svg" : "/images/HamburgerMenuOpen.svg"} 
          alt="Menu" 
        />
      </button>

      {isOpen && (
        <>
          <div className="menu-overlay" onClick={() => setIsOpen(false)}></div>
          <nav className="side-nav-menu">
            {/* Top bold menu items */}
            <div className="nav-item-bold">Pathweaver Studio</div>
            <div className="nav-item-bold">Learning Architect</div>
            <div className="nav-item-bold">My Courses</div>
            
            {/* LEARNER NAVIGATOR section */}
            <div className="side-nav-section">
              <div className="side-nav-section-title">LEARNER NAVIGATOR</div>
              
              {/* Expandable menu items */}
              <div 
                className={`nav-item-expandable ${expandedItems.genpal ? 'expanded' : ''} ${selectedItem === 'genpal' ? 'selected' : ''}`}
                onClick={() => handleItemClick('genpal')}
              >
                <span>GenPal</span>
                <svg className="dropdown-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              
              <div 
                className={`nav-item-expandable ${expandedItems.samvaad ? 'expanded' : ''} ${selectedItem === 'samvaad' ? 'selected' : ''}`}
                onClick={() => handleItemClick('samvaad')}
              >
                <span>Samvaad</span>
                <svg className="dropdown-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              
              <div 
                className={`nav-item-expandable ${expandedItems.genius ? 'expanded' : ''} ${selectedItem === 'genius' ? 'selected' : ''}`}
                onClick={() => handleItemClick('genius')}
              >
                <span>Genius Tutor</span>
                <svg className="dropdown-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              
              <div 
                className={`nav-item-expandable ${expandedItems.languageBuddy ? 'expanded' : ''} ${selectedItem === 'languageBuddy' ? 'selected' : ''}`}
                onClick={() => handleItemClick('languageBuddy')}
              >
                <span>Language Buddy</span>
                <svg className="dropdown-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              
              {/* Language Buddy sub-menu items */}
              {expandedItems.languageBuddy && (
                <div className="sub-menu">
                  <div className="sub-menu-item" onClick={() => handleNavigation('/learn')}>
                    Learn
                  </div>
                  <div className="sub-menu-item" onClick={() => handleNavigation('/practice')}>
                    Practice
                  </div>
                  <div className="sub-menu-item" onClick={() => handleNavigation('/assessment')}>
                    Assessment
                  </div>
                  <div className="sub-menu-item" onClick={() => handleNavigation('/cultural-insight')}>
                    Cultural Insights
                  </div>
                </div>
              )}
            </div>
          </nav>
        </>
      )}
    </>
  );
};

export default SideNav;
